import { isStringEmpty } from './objectUtils';
import ROUTES from '../constants/routes';

// single source of truth for launcher visibility, shared by the Intercom boot in AppWrapper, the
// route-change update in WrapperLayout, and the overlay-close restore in useHideIntercomLauncher
// so the three can never drift.
export const shouldHideIntercomLauncher = (pathname) => {
	if (isStringEmpty(pathname)) {
		return false;
	}

	return pathname.startsWith(ROUTES.MY_MESSAGES)
		|| pathname.startsWith(ROUTES.SUBSCRIPTION_REACTIVATION)
		|| pathname.startsWith(ROUTES.ENCOUNTER + '/')
		|| pathname.startsWith(ROUTES.ADMIN)
		|| pathname.startsWith(ROUTES.PROGRAM_FUNNEL + '/');
};
